import React from 'react';
import { CircleCheckIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
import { mockupAlt, mockupImage, offerIncludes } from '../data/kit';
import { useCheckoutUrl } from '../hooks/useCheckoutUrl';
import { trackPixelEvent } from '../utils/metaPixel';
export function OfferSection() {
  const checkoutUrl = useCheckoutUrl();
  return <section className="section mist" id="offer-details" aria-labelledby="offer-title" data-id="element-143" data-mp="dfgaj4x71ycf">
      <div className="wrap" data-id="element-144" data-mp="icorj26lvwc3">
        <div className="offer-wrap" data-id="element-145" data-mp="ifkux6183d7x">
          <p className="eyebrow" data-id="element-146" data-mp="me203k132dmp">The complete Volume 1 kit</p>
          <h2 id="offer-title" data-id="element-147" data-mp="rdwrdoort58a">
            Your next 13 weeks, organized.
            <br data-id="element-148" data-mp="repmttia48b4" />
            <span className="accent" data-id="element-149" data-mp="rc3l4ai2kn0t">One simple payment.</span>
          </h2>
          <article className="offer-card" data-id="element-150" data-mp="wc7znuzf37oe">
            <header className="offer-header" data-id="element-151" data-mp="2t5jcj9lze5wu">
              <h3 data-id="element-152" data-mp="2t6ued3vv93lb">Kids Activity Club — Volume 1</h3>
              <p data-id="element-153" data-mp="2y3ujnckw62bd">13 weekly sessions + 5 practical bonuses</p>
            </header>
            <div className="offer-body" data-id="element-154" data-mp="12niaveo1jzqb">
              <img className="product-mockup" src={mockupImage} alt={mockupAlt} loading="lazy" data-id="element-155" data-mp="12ojy0hic0coe" />
              <div className="offer-includes" data-id="element-156" data-mp="xvquty2ihcef">
                <p className="eyebrow" data-id="element-157" data-mp="xuyz8n8wzeo5">Everything included</p>
                <ul className="offer-list" data-id="element-158" data-mp="syid1yl9zadp">
                  {offerIncludes.map(item => <li key={item} data-id="element-159" data-mp="oxeuv5fr929b">
                      <CircleCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-160" data-mp="ouajno3vh695" />
                      <span data-id="element-161" data-mp="1lka168203f3v">{item}</span>
                    </li>)}
                </ul>
              </div>
              <div className="price" data-id="element-162" data-mp="1clfz425whwix">
                <strong className="price-amount" data-id="element-163" data-mp="1ckd9dxkbe04l">$27</strong>
                <span className="price-currency" data-id="element-164" data-mp="17mv8muggar7o">USD</span>
              </div>
              <p className="payment-type" data-id="element-165" data-mp="17oxwp8y1ma9r">One-time payment · Digital resources in English</p>
              <a className="cta" href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', {
              value: 27,
              currency: 'USD',
              content_name: 'Kids Activity Club — Volume 1',
              content_type: 'product'
            })} data-id="element-166" data-mp="14g8rc345rrj">
                GET MY 13-WEEK ACTIVITY KIT
              </a>
              <p className="offer-guarantee" data-id="element-167" data-mp="3otlhcj522qmh">
                <ShieldCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-168" data-mp="3b3i24c4lfx6j" />
                10-day return request window — see policy below
              </p>
              <div className="micro-row" data-id="element-169" data-mp="3fvjc1reahbte">
                <span data-id="element-170" data-mp="315lq7i3u0y7d">
                  <ShieldCheckIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-171" data-mp="316des8z0hvo5" />
                  Payment via Stripe
                </span>
                <span data-id="element-172" data-mp="3622f4eiuvgli">
                  <DownloadIcon className="icon" strokeWidth={1.8} aria-hidden="true" data-id="element-173" data-mp="2s4vx4m5yhlxc" />
                  Email delivery after approval
                </span>
              </div>
              <p className="scope-note" data-id="element-174" data-mp="2x5jpbb5x88t5">
                <strong data-id="element-175" data-mp="2dj019cfd9i4v">This package covers weeks 1–13.</strong> Additional volumes in the planned annual series are
                not included.
              </p>
            </div>
          </article>
          <p className="currency-note" data-id="element-176" data-mp="2mjog29cl3mit">
            The checkout shows your final amount, currency and available payment methods before you pay.
          </p>
        </div>
      </div>
    </section>;
}